import { I2087Form } from 'clickNgo/models/crud/forms'

import { CAMPAIGN_REMINDER_SEND_STATUS } from '../model/constants'
import { CampaignReminder, CampaignReminderSendStatus } from '../model/types'

import { parseCampaignReminderSendAt } from './campaignReminderDate'

const SEND_STATUS_VALUES = new Set<string>(Object.values(CAMPAIGN_REMINDER_SEND_STATUS))

const mapSendStatus = (sendStatus?: string): CampaignReminderSendStatus => {
  if (sendStatus && SEND_STATUS_VALUES.has(sendStatus)) {
    return sendStatus as CampaignReminderSendStatus
  }

  return CAMPAIGN_REMINDER_SEND_STATUS.PENDING
}

export function mapCampaignRemindersFrom2087(item: I2087Form): CampaignReminder {
  return {
    entryId: item.EntryId,
    campaignId: item.CampaignId,
    partnerId: item.PartnerId,
    sendAt: parseCampaignReminderSendAt(item.SendAt),
    sendStatus: mapSendStatus(item.SendStatus),
    sendTo: item.SendTo,
  }
}
